/* Presentation only: uses the existing controller, without cart requests or mutations. */
class EmptyCartGiftOffer extends HTMLElement {
  connectedCallback() {
    this.listeners?.abort();
    this.listeners = new AbortController();
    const options = { signal: this.listeners.signal };
    document.addEventListener('gift-offer:state', event => this.render(event.detail), options);
    document.addEventListener('gift-offer:error', () => { this.hidden = true; }, options);
    this.render(document.querySelector('gift-offer-controller')?.state);
  }

  disconnectedCallback() {
    this.listeners?.abort();
  }

  render(state) {
    const controller = document.querySelector('gift-offer-controller');
    let presentation;
    try {
      presentation = JSON.parse(controller?.querySelector('[data-gift-presentation]')?.textContent || 'null');
    } catch {
      this.hidden = true;
      return;
    }
    if (!state || !presentation?.showEmptyCart || !presentation.productTitle ||
      !state.enabled || !state.active || state.error ||
      !Array.isArray(state.cart?.items) || state.cart.items.length !== 0 ||
      !Number.isFinite(state.threshold) || state.threshold <= 0 || !/^[A-Z]{3}$/.test(state.currency)) {
      this.hidden = true;
      return;
    }
    const signature = JSON.stringify([presentation, state.threshold, state.currency]);
    if (this.lastPresentation !== signature) {
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: state.currency, currencyDisplay: 'code', minimumFractionDigits: 0
      }).format(state.threshold / 100);
      this.querySelector('[data-empty-gift-heading]').textContent = presentation.heading || 'Free gift with your purchase';
      this.querySelector('[data-empty-gift-copy]').textContent =
        `Receive ${presentation.productTitle} free with a qualifying purchase of at least ${amount}.`;
      const image = this.querySelector('[data-empty-gift-image]');
      image.hidden = !presentation.image;
      if (presentation.image) {
        if (image.getAttribute('src') !== presentation.image) image.setAttribute('src', presentation.image);
        image.alt = presentation.productTitle;
      } else {
        image.removeAttribute('src');
        image.alt = '';
      }
      this.lastPresentation = signature;
    }
    this.hidden = false;
  }
}

if (!customElements.get('empty-cart-gift-offer')) {
  customElements.define('empty-cart-gift-offer', EmptyCartGiftOffer);
}
